import React from 'react'
import PropTypes from 'prop-types'
import { Marker, Tooltip } from 'react-leaflet'
import L from 'leaflet'
import './style.scss'
import { getGeographyObject } from 'shared/utilities/routeUtils'
import getGeographyLabelPosition from './getGeographyLabelPosition'

const INVISIBLE_MARKER_ICON = L.divIcon({
  className: 'geography-marker-invisible',
  html: '',
  iconSize: [0, 0],
  iconAnchor: [0, 0],
})

const isHighlightedGeography = (geography, currentGeographyId, changingGeographyId) => {
  const id = geography.data.properties.id
  return id == currentGeographyId || id == changingGeographyId
}

const GeographyMarkerLabels = props => {
  const geographyObject = getGeographyObject(props.currentGeographyType)
  if (!props.geographies.length) return null
  return props.geographies
    .filter(
      geography =>
        (geographyObject.hidden && !geographyObject.hidden.includes(geography.id)) ||
        (!geographyObject.hidden && geographyObject)
    )
    .map((geography, index) => {
      const atTop = isHighlightedGeography(
        geography,
        props.currentGeographyId,
        props.changingGeographyId
      )
      return (
        <Marker
          key={`geography-label-${index}`}
          interactive={false}
          icon={INVISIBLE_MARKER_ICON}
          position={getGeographyLabelPosition(geography, { atTop })}
        >
          <Tooltip
            permanent
            direction="top"
            offset={atTop ? [0, 4] : [0, 0]}
            className={`geography-marker__tooltip geography-marker__tooltip--${props.currentGeographyType}`}
          >
            <span className="geography-marker-label">{String(geography.data.properties.id)}</span>
          </Tooltip>
        </Marker>
      )
    })
}

GeographyMarkerLabels.defaultProps = {
  geographies: [],
}

GeographyMarkerLabels.propTypes = {
  geographies: PropTypes.array,
  currentGeographyType: PropTypes.string,
  currentGeographyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  changingGeographyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default GeographyMarkerLabels
